import pageMenu from './../components/experiences-page/page-menu';
import smallSliders from './../components/experiences-page/small-sliders';

export default () => {
  pageMenu()
  smallSliders()
}
